// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"711b3fde","464":"bf5575d6","941":"1862e8dc"}[chunkId] + ".chunk.css";
};